//data menu navbar
export const navItems = [
  { id: 'home'},
  { id: 'about' },
  { id: 'benefit'},
  { id: 'features'},
  { id: 'partners'},
  { id: 'blog' },
  { id: 'faq'},
  // { id: 'contact'},
]


export const Logos = {
    edunav: "/assets/edunav.png",
    edunavAI1 : "/assets/edunav-ai.webp",
    edunavAI2 : "/assets/edunav by-zerone.webp",
    ujianOnline : "/assets/ujian online canggih.webp",
    edunavMoc : "/assets/edunav.webp",
    payment : "/assets/payment.webp",
    heroedunav : "/assets/Edunav-hero.webp",
    playstore : "/assets/hr-playstore.png",
    appstore : "/assets/hr-appstore.png",
    microsoftstore : "/assets/hr-microsoftstore.png",
    edunavMobile : "/assets/edunav-mobile.webp",
    edunavBanner : "/assets/edunav-banner.webp",
    komdigi : "/assets/komdigi.png",
    edunavMockup : "/assets/edunav-mockup.webp",
    indonesia : "/assets/indonesia.png",
    unitedkingdom : "/assets/united-kingdom.png",
    benefitAssessment : "/assets/penilaian guru dan siswa.png",
    benefitLms : "/assets/sistem manajemen pembelajaran.png",
    benefitFinance : "/assets/modul keuangan.png",
}

export const footerLogos = {
    instagram : "/assets/instagram.png",
    whatsapp : "/assets/whatsapp.png",
    playstore : "/assets/playstore2.png",
    appstore : "/assets/appstore2.png",
}



export const partnerLogos = [
  {
    id: 1,
    name: "Sampoerna Academy",
    image: "/assets/logo-partner/sampoerna.png",
    alt: "Logo Sampoerna Academy - sekolah internasional yang menggunakan Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 2,
    name: "Kharisma Bangsa",
    image: "/assets/logo-partner/kharisma.png",
    alt: "Logo Kharisma Bangsa - sekolah unggulan yang mempercayakan Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 3,
    name: "Kesatuan Bangsa",
    image: "/assets/logo-partner/kesatuan-bangsa.png",
    alt: "Logo Kesatuan Bangsa - sekolah bilingual yang menggunakan Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 4,
    name: "Semesta",
    image: "/assets/logo-partner/semesta.png",
    alt: "Logo Semesta Bilingual Boarding School - partner Edunav untuk Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 5,
    name: "Al-Azhar BSD",
    image: "/assets/logo-partner/alazhar-bsd.png",
    alt: "Logo Al-Azhar BSD - sekolah Islam terpadu yang menggunakan Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 6,
    name: "Al-Azhar Cileungsi",
    image: "/assets/logo-partner/alhazhar-cileungsi.png",
    alt: "Logo Al-Azhar Cileungsi - implementing Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 7,
    name: "Cahaya Rancamaya",
    image: "/assets/logo-partner/cahaya-rancamaya.png",
    alt: "Logo Cahaya Rancamaya Islamic Boarding School - pengguna Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 8,
    name: "Darul Hikmah",
    image: "/assets/logo-partner/darul-hikmah.png",
    alt: "Logo Darul Hikmah - sekolah yang menggunakan Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 9,
    name: "EIBOS",
    image: "/assets/logo-partner/eibos.png",
    alt: "Logo EIBOS - partner Edunav untuk Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 10,
    name: "Fatih Bilingual School",
    image: "/assets/logo-partner/fatih.png",
    alt: "Logo Fatih Bilingual Boarding School - menggunakan Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 11,
    name: "Fountain",
    image: "/assets/logo-partner/fountain.png",
    alt: "Logo Fountain School - partner Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 12,
    name: "Global Cahaya Bangsa",
    image: "/assets/logo-partner/global-cahaya-bangsa.webp",
    alt: "Logo Global Cahaya Bangsa - sekolah yang menggunakan Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 13,
    name: "Harapan Ibu",
    image: "/assets/logo-partner/harapan-ibu.png",
    alt: "Logo Harapan Ibu - implementing Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 14,
    name: "Harmoni Wisdom",
    image: "/assets/logo-partner/harmoni-wisdom.png",
    alt: "Logo Harmoni Wisdom School - partner Edunav untuk Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 15,
    name: "Hibiscus",
    image: "/assets/logo-partner/hibicus.png",
    alt: "Logo Hibiscus School - pengguna Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 16,
    name: "Horizon School",
    image: "/assets/logo-partner/horizon.png",
    alt: "Logo Horizon School - partner Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 17,
    name: "IIBS",
    image: "/assets/logo-partner/iibs.png",
    alt: "Logo IIBS - sekolah yang menggunakan Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 18,
    name: "IQ Belia",
    image: "/assets/logo-partner/iq-belia.png",
    alt: "Logo IQ Belia - implementing Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 19,
    name: "MEGA",
    image: "/assets/logo-partner/mega.png",
    alt: "Logo MEGA School - partner Edunav untuk Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 20,
    name: "MIP",
    image: "/assets/logo-partner/mip.png",
    alt: "Logo MIP - pengguna Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 21,
    name: "Prestige",
    image: "/assets/logo-partner/prestige.png",
    alt: "Logo Prestige School - partner Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 22,
    name: "Pribadi School",
    image: "/assets/logo-partner/pribadi.png",
    alt: "Logo Pribadi School - menggunakan Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 23,
    name: "Pribadi Bandung",
    image: "/assets/logo-partner/pribadi-bandung.png",
    alt: "Logo Pribadi Bandung - sekolah yang implementing Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 24,
    name: "Pribadi Premier",
    image: "/assets/logo-partner/pribadi-premier.png",
    alt: "Logo Pribadi Premier - partner Edunav untuk Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 25,
    name: "Samarinda",
    image: "/assets/logo-partner/samarinda.png",
    alt: "Logo sekolah Samarinda - pengguna Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 26,
    name: "Saritha",
    image: "/assets/logo-partner/saritha.png",
    alt: "Logo Saritha School - menggunakan Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 27,
    name: "SMA Prestasi Samarinda",
    image: "/assets/logo-partner/sma prestasi samarinda.webp",
    alt: "Logo SMA Prestasi Samarinda - sekolah unggulan dengan Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 28,
    name: "SMI CCI",
    image: "/assets/logo-partner/smi-cci.png",
    alt: "Logo SMI CCI - partner Edunav untuk Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 29,
    name: "SMP 16 Samarinda",
    image: "/assets/logo-partner/smp 16 samarinda.webp",
    alt: "Logo SMP 16 Samarinda - implementing Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 30,
    name: "Teuku Nyak Arif",
    image: "/assets/logo-partner/teuku-nyak-arif.png",
    alt: "Logo Teuku Nyak Arif - sekolah yang menggunakan Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 31,
    name: "TK SD Muslim Cendikia",
    image: "/assets/logo-partner/TK-SD-MUSLIM-CENDIKIA.png",
    alt: "Logo TK SD Muslim Cendikia - partner Edunav untuk Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 32,
    name: "Tolerance",
    image: "/assets/logo-partner/tolerance.png",
    alt: "Logo Tolerance School - pengguna Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 34,
    name: "CGS",
    image: "/assets/logo-partner/cgs.png",
    alt: "Logo CGS School - implementing Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 35,
    name: "Dwiwarna",
    image: "/assets/logo-partner/dwiwarna.png",
    alt: "Logo Dwiwarna Boarding School - menggunakan Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 36,
    name: "Little Thinkers",
    image: "/assets/logo-partner/litle-thinkers.png",
    alt: "Logo Little Thinkers - partner Edunav untuk Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 37,
    name: "TK Air",
    image: "/assets/logo-partner/TK AIR.png",
    alt: "Logo TK Air - sekolah yang menggunakan Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 38,
    name: "RWS",
    image: "/assets/logo-partner/logo-RWS.png",
    alt: "Logo RWS School - pengguna Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 39,
    name: "SD Negeri 29 Sungai Kunjang",
    image: "/assets/logo-partner/sd-negeri-29-sungai-kunjang.png",
    alt: "Logo SD Negeri 29 Sungai Kunjang - sekolah negeri yang implementing Edunav sebagai Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
  {
    id: 40,
    name: "PAKAR-BELIA",
    image: "/assets/logo-partner/PAKAR-BELIA.png",
    alt: "Logo PAKAR-BELIA - partner Edunav untuk Sistem Informasi Sekolah by Zerone Digital Global Solution",
  },
];

// Sample blog posts
export const posts = [
  {
    id: 'getting-started-edunav',
    title: 'Getting Started with Edunav: A Quick Guide',
    date: '2025-11-01',
    image: '/assets/Edunav-hero.webp',
    excerpt:
      'Pelajari langkah awal menggunakan Edunav untuk meningkatkan manajemen sekolah Anda.',
    content:
      '<p>Edunav membantu sekolah mengelola data siswa, absensi, pembayaran, dan komunikasi dengan mudah. Dalam artikel ini kita akan membahas pengaturan awal, integrasi, dan tips penggunaan.</p>'
  },
  {
    id: 'ai-in-education',
    title: 'How AI Powers Lesson Planning in Edunav',
    date: '2025-10-15',
    image: '/assets/edunav-mockup.webp',
    excerpt: 'Fitur AI Edunav mempercepat pembuatan RPP dan materi ajar sesuai kurikulum.',
    content:
      '<p>Dengan model AI yang terintegrasi, guru dapat membuat RPP otomatis, menyesuaikan tujuan pembelajaran, dan menghasilkan penilaian formatif.</p>'
  },
  {
    id: 'success-stories',
    title: 'Success Stories: Schools That Transformed with Edunav',
    date: '2025-09-30',
    image: '/assets/Edunav-hero.webp',
    excerpt:
      'Kisah nyata sekolah yang meningkatkan efisiensi operasional berkat Edunav.',
    content:
      '<p>Beberapa sekolah melihat penurunan waktu administrasi hingga 60% setelah mengadopsi Edunav. Berikut studi kasusnya.</p>'
  },  {
    id: 'success-stories',
    title: 'Success Stories: Schools That Transformed with Edunav',
    date: '2025-09-30',
    image: '/assets/edunav-mockup.webp',
    excerpt:
      'Kisah nyata sekolah yang meningkatkan efisiensi operasional berkat Edunav.',
    content:
      '<p>Beberapa sekolah melihat penurunan waktu administrasi hingga 60% setelah mengadopsi Edunav. Berikut studi kasusnya.</p>'
  },  {
    id: 'success-stories',
    title: 'Success Stories: Schools That Transformed with Edunav',
    date: '2025-09-30',
    image: '/assets/Edunav-hero.webp',
    excerpt:
      'Kisah nyata sekolah yang meningkatkan efisiensi operasional berkat Edunav.',
    content:
      '<p>Beberapa sekolah melihat penurunan waktu administrasi hingga 60% setelah mengadopsi Edunav. Berikut studi kasusnya.</p>'
  },
];
